import EventBus from '../../utils/EventBus';
import sortBy from 'lodash/sortBy';

export default {
    props: {
        config: {
            type: Object,
            default: function() {
                return {};
            }
        },
        initial: ''
    },
    data: function() {
        return {
            orderBy: this.initial || 'default',
            items: [],
            originalItems: []
        }
    },
    watch: {
        orderBy: function(newVal, oldVal) {
            let sortedItems;

            if (newVal === 'default') {
                // Default sorting
                sortedItems = this.originalItems;
            } else if (newVal === 'price_asc') {
                sortedItems = sortBy(this.items, [function(item) {
                    return item.price;
                }, function(item) {
                    return item.index;
                }]);
            }

            // And append to box
            sortedItems.forEach((item) => {
                this.itemsHolderEl.appendChild(item.element);
            });

            // Emit event
            EventBus.$emit('ProductListing:onSort', { oldVal, newVal }, this.config.eventData);
        }
    },
    mounted() {
        this.itemsHolderEl = this.$refs.items;
        const elements = this.itemsHolderEl.children;
        this.items = Array.from(elements, (element) => {
            const productJson = JSON.parse(element.getAttribute('data-product-item'));
            return {
                index: parseInt(productJson.index),
                price: parseInt(productJson.price),
                element: element
            }
        });
        this.originalItems = this.items.slice(); // Copy of original
        if (typeof window.picturefill === 'function') {
            window.picturefill(this.itemsHolderEl);
        }
        if(window.Modernizr && !window.Modernizr.objectfit) {
            this.$nextTick(async function() {
                const ObjectFit = (await import('../../utils/polyfills/ObjectFit.js')).default;
                ObjectFit.setElementStyles();
            });
        }
    }
};
